<div class="wrapper">
    <div class="auth-panel">

        <ng-container *ngIf="stage == 0">
            <div class="line">
                <input [(ngModel)]="phone" placeholder="Номер телефона">
                <div class="button" (click)="nextStage()">Получить код</div>
            </div>
        </ng-container>

        <ng-container *ngIf="stage == 1">
            <div class="phone">{{ phone }}</div>
            <div class="line">
                <input [(ngModel)]="code" placeholder="СМС код">
                <div class="button" (click)="auth()">Войти</div>
            </div>
        </ng-container>

    </div>
</div>
